import Cookies from 'universal-cookie';
const cookies = new Cookies();

const option = {
  path: '/'
};

function setCookie(key, value) {
  return cookies.set(key, value, option);
}

function getCookie(key) {
  return cookies.get(key);
}

function delCookie(key) {
  return cookies.remove(key, option);
}

export { setCookie, getCookie, delCookie };



// WEBPACK FOOTER //
// ./src/helper/cookieClient.js